module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_request_001_lg-b6cd605f.png";